import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { ExtraccionistaMedicalService } from "src/app/services/extraccionista-medical-service/extraccionista-medical-service.service";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { PracticeService } from "../../../services/practice.service";
import { AuthService } from "../../../services/auth.service";
import { MedicalServiceService } from "../../../services/medical-service.service";

@Component({
  selector: "app-extraccionista-filter",
  templateUrl: "./extraccionista-filter.component.html",
  styleUrls: ["./extraccionista-filter.component.css"],
})
export class ExtraccionistaFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private emService: ExtraccionistaMedicalService,
    private practiceService: PracticeService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      date: [new Date()],
      practiceRegion: [null],
      patient: [null],
      atended: [false],
      interned: [false],
    });

    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.practiceRegion
      );
  }

  get f() {
    return this.form.controls;
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "ExtraccionistaFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "ExtraccionistaFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    try {
      if (this.form.valid) {
        return this.emService.getMedicalAppointments(
          this.form.controls.date.value,
          this.form.controls.atended.value,
          this.form.controls.interned.value,
          this.form.controls.practiceRegion.value
            ? this.form.controls.practiceRegion.value.Id
            : null,
          this.form.controls.patient.value
            ? this.form.controls.patient.value.Id
            : null
        );
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async ngOnInit() {
    const sectorId = this.authService.getSectorId();

    this.filterCompletePracticesRegion = sectorId
      ? new FilterCompleteService<PracticeRegionFilter>(
          await this.practiceService.getPracticesRegionFilterSectorId(sectorId),
          this.form.controls.practiceRegion
        )
      : new FilterCompleteService<PracticeRegionFilter>(
          await this.practiceService.getPracticesRegionFilter(),
          this.form.controls.practiceRegion
        );
  }
}
